<template>
  <el-tooltip
      :value="showTooltip"
      content="コピーしました"
      manual>
    <el-button
        :disabled="disabled"
        icon="el-icon-document"
        @click="handleClick">
      <slot />
    </el-button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'BaseCopyButton',
  props: {
    text: {
      type: String,
      required: true,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showTooltip: false,
      timeoutId: null
    }
  },
  methods: {
    handleClick (evt) {
      var textArea = document.createElement('textarea')
      textArea.value = this.text
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }
      this.showTooltip = true
      this.timeoutId = setTimeout(
        () => {
          this.timeoutId = null
          this.showTooltip = false
        }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/BaseCopyButton.vue